module.exports = __webpack_public_path__ + "media/images/flags/tg-9d3ea4ccd0d0934eeb670722019438e1.svg";